"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundManager = void 0;
const sounds_1 = require("./sounds");
const injets_1 = require("injets");
let SoundManager = class SoundManager {
    constructor() {
        this.sounds = new Map();
        this
            .load(sounds_1.GameSounds.CREDITS)
            .load(sounds_1.GameSounds.PIXELS)
            .load(sounds_1.GameSounds.RECEIVE_MSG)
            .load(sounds_1.GameSounds.SENT_MSG);
    }
    add(id, audio) {
        this.sounds.set(id, audio);
        return this;
    }
    register(id, url) {
        const audio = new Audio(url);
        this.sounds.set(id, audio);
        audio.load();
        return audio;
    }
    load(sound) {
        this.register(sound, sound);
        return this;
    }
    play(sound, loop = false) {
        const audio = this.sounds.get(sound);
        if (audio) {
            audio.loop = loop;
            audio.play();
        }
        return this;
    }
};
SoundManager = __decorate([
    injets_1.Provider(),
    __metadata("design:paramtypes", [])
], SoundManager);
exports.SoundManager = SoundManager;
